import { StoreConfig, Query, Store } from '@datorama/akita';
import produce from 'immer';

export interface SessionState {
  isLoggedIn: boolean;
}

const createInitialState = (): SessionState => ({
  isLoggedIn: false,
});

@StoreConfig({ name: 'sessionStore', producerFn: produce })
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createInitialState());
  }
}

export class SessionQuery extends Query<SessionState> {
  readonly loggedIn$ = this.select((state) => state.isLoggedIn);
  readonly loading$ = this.selectLoading();
  readonly error$ = this.selectError();

  constructor(protected store: SessionStore) {
    super(store);
  }
}

export const sessionStore = new SessionStore();
export const sessionQuery = new SessionQuery(sessionStore);
